import { cn } from "@/shared/lib/utils"

/**
 * Solid surface, no border: on the gray-900 page a single tone step is enough to read as a card,
 * and nested content separates itself with hairline dividers instead of more boxes.
 */
const CardRoot: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
  <div
    {...props}
    className={cn("rounded-2xl bg-gray-800 text-gray-100", className)}
  />
)
CardRoot.displayName = "Card"

const Header: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
  <div
    {...props}
    className={cn("flex flex-col space-y-1 p-4 sm:p-5", className)}
  />
)
Header.displayName = "Card.Header"

const Title: React.FC<React.ComponentProps<"h3">> = ({ className, children, ...props }) => (
  <h3
    {...props}
    className={cn("text-base font-semibold leading-tight tracking-tight", className)}>
    {children}
  </h3>
)
Title.displayName = "Card.Title"

const Description: React.FC<React.ComponentProps<"p">> = ({ className, ...props }) => (
  <p
    {...props}
    className={cn("text-sm text-gray-400", className)}
  />
)
Description.displayName = "Card.Description"

const Content: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
  <div
    {...props}
    className={cn("p-4 pt-0 sm:p-5 sm:pt-0", className)}
  />
)
Content.displayName = "Card.Content"

export const Card = Object.assign(CardRoot, {
  Header,
  Title,
  Description,
  Content
})

// Backwards compatibility exports
export { Header as CardHeader, Title as CardTitle, Description as CardDescription, Content as CardContent }
